/* eslint-disable quote-props */
import React, { useState } from 'react';
// @mui
import { Select, MenuItem, Typography } from '@mui/material';
import config from 'config';
import helper from 'utils/helper';

export default function CurrencyPopover() {
    const currencies = config.currenciesCodes;
    const [selectedCurrency, setSelectedCurrency] = useState(
        currencies.find((c) => c === (localStorage.currency || 'CHF'))
    );

    const handleCurrencyChange = async (newCurrency) => {
        setSelectedCurrency(newCurrency);
        await helper.changeCurrency(newCurrency);
    };

    return (
        <Select
            value={selectedCurrency}
            onChange={(e) => handleCurrencyChange(e.target.value)}
            sx={{
                height: '32px',
                minHeight: '32px',
                '& .MuiSelect-select': {
                    paddingTop: '4px',
                    paddingBottom: '4px',
                    paddingLeft: '12px',
                    paddingRight: '32px',
                    fontSize: '14px',
                    fontWeight: 600,
                    color: '#344054',
                    display: 'flex',
                    alignItems: 'center'
                },
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#E0E0E0',
                    borderRadius: '8px'
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#BDBDBD'
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#91733D'
                },
                '& .MuiSelect-icon': {
                    color: '#424242',
                    fontSize: '18px',
                    fontWeight: 700,
                    transform: 'scale(1.2)'
                }
            }}
        >
            {currencies.map((cur) => (
                <MenuItem key={cur} value={cur}>
                    <Typography variant="subtitle2">{cur}</Typography>
                </MenuItem>
            ))}
        </Select>
    );
}
